export default "__VITE_ASSET__CtDuUAQu__"